import { Component, ViewChild, NgModule } from '@angular/core';

import { FicheGeneriqueComponent, BarreMenusComponent, DonneesMenuItem } from '../../../../../../../val-ammon-composants/val-composants-lib/src/public-api';
import { RetournerVueAchatResultat } from '../../../RetournerVueAchatResultat';
import { VueFactureAchatFicheContenuComponent } from '../vue-facture-achat-fiche-contenu/vue-facture-achat-fiche-contenu.component';

//Composant fiche de la facture d'achat - Modal
@Component(
  {
    selector: 'val-facture-achat-fiche',
    imports:[
      BarreMenusComponent,
      FicheGeneriqueComponent,
      VueFactureAchatFicheContenuComponent
    ],
    templateUrl: './vue-facture-achat-fiche.component.html',
    styleUrls: ['./vue-facture-achat-fiche.component.scss']
  })
export class VueFactureAchatFicheComponent {
  
  // Fiche générique
  @ViewChild("ficheGenerique")
  public ficheGenerique!: FicheGeneriqueComponent<RetournerVueAchatResultat>;

  // Composant contenu réutilisable
  @ViewChild("ficheContenu")
  public ficheContenu!: VueFactureAchatFicheContenuComponent;

  // Ouvre la fiche de consultation de la facture d'achat
  // Paramètres
  //  id : Identifiant de l'achat
  // Retourne
  //    Données de consultation de l'achat
  public async Ouvrir(id: string): Promise<RetournerVueAchatResultat> {
    // Charger les données via le composant contenu
    await this.ficheContenu.ChargerDonnees(id);

    const operation = this.ficheGenerique.Ouvrir();
    return operation;
  }

  // Ferme la fiche de consultation de la facture d'achat  
  public Fermer(): void {
    this.ficheGenerique.Fermer();
  }
  
  // Les données du menu
  public menuItems(): DonneesMenuItem[] {
    return this.ficheContenu?.menuItems && !this.ficheContenu.AucuneDonnee() ? this.ficheContenu.menuItems : [];
  }
}
